<template>
  <v-carousel
      :height="height"
      :width="width ? width : 'auto'"
      hide-delimiters
  >
    <template v-slot:prev="{ on, attrs }">
      <LeftIcon
          v-bind="attrs"
          v-on="on"
      ></LeftIcon>
    </template>
    <template v-slot:next="{ on, attrs }">
      <RightIcon
          v-bind="attrs"
          v-on="on"
      ></RightIcon>
    </template>

    <v-carousel-item
      :contain="contain ? true : false"
      v-for="(item, i) in imageList"
      :key="i"
      :src="item ? s3BucketURL + item : images[default_image]"
      reverse-transition="fade-transition"
      transition="fade-transition"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
import images from "@/utils/images";
import RightIcon from "@/assets/images/misc/right-icon.svg";
import LeftIcon from "@/assets/images/misc/left-icon.svg";
export default {
  props: {
    imageList: { type: Array, default: null },
    height: { type: Number, default: 120 },
    width: { type: Number, default: null },
    default_image: { type: String, default: "default" },
    contain: { type: Boolean, default: false },
  },
  components:{
    RightIcon,LeftIcon
  },
  data() {
    return {
      images: images,
    };
  },
};
</script>

<style scoped>
.v-window__prev{
  background: transparent;
}
</style>
